module.exports = __webpack_public_path__ + "static/media/bg-general.871a6c56.png";